const STORAGE_KEY = 'welya.affiliate';
const SEARCH_PARAM = 'affiliate';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const MAX_LENGTH = 50;

// Le token d'affiliation First Promoter et le code promo Stripe sont deux valeurs distinctes.
export const LIBERTY_WEBI_REFERRAL = 'liberty40';
export const LIBERTY_WEBI_PROMO_CODE = 'LW40';

type StoredAffiliate = {
  code: string;
  expiresAt: number;
};

function readRaw(): StoredAffiliate | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;
    const { code, expiresAt } = parsed as Partial<StoredAffiliate>;
    if (typeof code !== 'string' || typeof expiresAt !== 'number') return null;
    return { code, expiresAt };
  } catch {
    return null;
  }
}

export function clearStoredAffiliate(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // stockage indisponible (navigation privée, bloqueur) : sans effet sur le parcours
  }
}

export function captureAffiliateFromSearch(search: string, now: number): void {
  const code = new URLSearchParams(search).get(SEARCH_PARAM)?.trim();
  if (!code || code.length > MAX_LENGTH) return;

  try {
    const payload: StoredAffiliate = { code, expiresAt: now + TTL_MS };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // idem : l'attribution est perdue, l'inscription continue
  }
}

export function readStoredAffiliate(now: number): string | null {
  const stored = readRaw();
  if (!stored) return null;
  if (stored.expiresAt <= now) {
    clearStoredAffiliate();
    return null;
  }
  return stored.code;
}

export function isLibertyWebiReferral(code: string | null): boolean {
  return code !== null && code.trim().toLowerCase() === LIBERTY_WEBI_REFERRAL;
}
